module.exports = __webpack_public_path__ + "static/media/check-round-icon.98cfc65e.svg";